import Vue from 'vue';
import Vuex from 'vuex';
import map from './map';
import app from './app';
import run from './run';
import views from './views';
import config from './config'

let modules = Object.assign({}, {
	app,
	run,
	map,
  config
}, views);

Vue.use(Vuex);

export default new Vuex.Store({
  modules
});
